import { cn } from '../../lib/cn';
import type { StatusTone } from '../../lib/metrics';

const FILL: Record<StatusTone, string> = {
  good: 'bg-accent',
  neutral: 'bg-accent',
  warning: 'bg-warning',
  critical: 'bg-critical',
};

interface MeterProps {
  /** 0–100. */
  percent: number;
  /** Alert threshold (0–100), drawn as a tick so headroom is visible at a glance. */
  threshold?: number;
  tone?: StatusTone;
  /** Draw on the band instead of a white panel. */
  onBand?: boolean;
  className?: string;
}

/** A rounded percentage meter: blue within limits, amber/red when its rule is breaching or firing. */
export function Meter({ percent, threshold, tone = 'good', onBand = false, className }: MeterProps) {
  const clamp = (v: number) => Math.max(0, Math.min(100, v));
  return (
    <div className={cn('relative h-1.5 w-full rounded-full', onBand ? 'bg-band-raised' : 'bg-grid', className)} aria-hidden>
      <div
        className={cn('h-full rounded-full', onBand && (tone === 'good' || tone === 'neutral') ? 'bg-band-accent' : FILL[tone])}
        style={{ width: `${clamp(percent)}%` }}
      />
      {threshold !== undefined && (
        <div
          className={cn('absolute -top-[3px] h-3 w-0.5 rounded-full', onBand ? 'bg-band-fg' : 'bg-fg-secondary')}
          style={{ left: `calc(${clamp(threshold)}% - 1px)` }}
        />
      )}
    </div>
  );
}
